export const GAP = 10;

export const TABLE_FONT_SIZE = 8;

export const PAGE_COLOR = '#004F6B';

export const PAGE_CHILD_COLOR = '#9CA3AF';

export const MAX_COLUMNS_PER_CATEGORY = {
  ledgers: 15,
  invoice: 15,
  invoices: 15,
  patientInvoices: 15
};

// custom style for columns of table based on category name
export const CATEGORY_TABLE_COLUMNS_STYLE = {
  terminalData: { PIN: { cellWidth: 60 } }
};

export const PORTRAIT_MAX_COLUMNS = 10;
export const LANDSCAPE_MAX_COLUMNS = 15;
export const CELL_LENGTH_MULTIPLE = 2.5;

/** Minimum width (in mm) for each column in exported PDF tables. Increase if columns are too narrow. */
export const MIN_COLUMN_WIDTH = 15;

/**
 * Fallbacks only. The queued-export registry and its threshold live in the backend
 * (`@utility/export/constants`) and are served by `/api/export/config`; a local copy of the
 * dataset list would go stale the moment a second dataset is registered, so the fallback
 * disables the queued path rather than guessing at it.
 */
export const ASYNC_EXPORT_ROW_THRESHOLD = Infinity;

export const ASYNC_EXPORT_DATASETS = [];
